import Breadcrumb from '@/components/common/Breadcrumb';
import EscalationListPage from './components/EscalationListPage';
// import data1 from '@/constants/auditEvents';
// import useUserInfo from '@/components/Authenticate/useUserInfo';
// import { TASK_QUERY } from '@/graphql/queries/record-management';
// // import { createTaskPayload, getPractitionerId, getTaskId } from '@/lib/utils';
// import { getPractitionerId } from '@/lib/utils';
// import { taskQueryBusinessStatus } from '@/constants';
// import { useState } from 'react';
// import DocumentReport from './components/DocumentReport';
// import { useQuery } from '@apollo/client';

export default function Supervisor() {
  // TODO: Might be needed in future
  // const [isFullView, setIsFullView] = useState<boolean>(false);
  // const [date, setDate] = useState<Date | null>(new Date());
  // const { userInfo } = useUserInfo();
  // const practitionerId = getPractitionerId(userInfo);
  // const queryVariables = {
  //   business_status: taskQueryBusinessStatus.documentSupervisorBusinessStatus.toString(),
  //   owner: `Practitioner/${practitionerId}`,
  //   fallback_business_status: taskQueryBusinessStatus.documentSupervisorFallbackBusinessStatus.toString(),
  //   count: 1000
  // };

  // const { data } = useQuery(TASK_QUERY, { variables: queryVariables });
  // const taskDetails = data?.primary?.[0] ?? data?.fallback?.[0] ?? {};
  // console.log('taskDetails', taskDetails);
  // const data = data1;
  // console.log('data', data);
  return (
    <div className="p-8 h-full background-periwinkle-20">
      <Breadcrumb
        items={[
          { label: 'Dashboard', path: '/' },
          { label: 'Escalations', path: '/supervisor' },
        ]}
      />
      <div className="flex">
        <div className='w-full'>
          <div className="flex flex-row self-center justify-between">
            
            {/* <button
              className="self-center text-iris-100"
              onClick={() => setIsFullView(!isFullView)}
            >
              View All
            </button> */}
          </div>
          <div>
            <EscalationListPage />
          </div>
        </div>

        {/* {isFullView ? null : (
          <DocumentReport
            date={date}
            setDate={(value: Date | null) => setDate(value)}
            placeholder={'Select Date'}
          />
        )} */}
      </div>
    </div>
  );
}